export enum ImportExistingStep {
  IMPORT_SWTICH = 'import_switch',
  ENTER_SEED_PHRASE = 'enter_seed_phrase',
  SEED_PASSPHRASE = 'seed_passphrase',
  ENTER_PRIVATE_KEY = 'enter_private_key',
  IMPORT_BACKUP = 'import_backup',
  CREATE_PIN = 'create_pin',
  SUCCESS = 'success',
  ERROR = 'error',
}
